import axios from "axios";
import store from "../../store";
import {
  ROOT_URL,
  API_ROOT,
  COLLECTIONS,
  CDG_API,
  NODE_API,
  SCORE_API,
  ACCESS_API,
  ORDER_API,
} from "../urls";

const _getAxios = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        store.dispatch("addNotification", {
          errorBody: err.response.data,
          type: "errorMessage",
          message: `An error with status code ${err.response.status} has occured`,
        });
        reject(err);
      });
  });
};
const _postAxios = (url, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, payload)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        store.dispatch("addNotification", {
          errorBody: err.response.data,
          type: "errorMessage",
          message: `An error with status code ${err.response.status} has occured`,
        });
        reject(err);
      });
  });
};

const _putAxios = (url, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, payload)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        store.dispatch("addNotification", {
          errorBody: err.response.data,
          type: "errorMessage",
          message: `An error with status code ${err.response.status} has occured`,
        });
        reject(err);
      });
  });
};

const _deleteAxios = (url, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { data: payload })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        store.dispatch("addNotification", {
          errorBody: err.response.data,
          type: "errorMessage",
          message: `An error with status code ${err.response.status} has occured`,
        });
        reject(err);
      });
  });
};

export const getAllCatRootNodes = () => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/--all--/get_recs`;
  return _getAxios(url);
};
export const getAllRecordRootNodes = () => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/--all--/get_recs`;
  return _getAxios(url);
};
export const getAllTemplateRootNodes = () => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/--all--/get_recs`;
  return _getAxios(url);
};
export const getAllUoms = () => {
  const url = `${API_ROOT}/${COLLECTIONS.UOMS}/--all--/get_recs`;
  return _getAxios(url);
};
export const getAllGlossarys = () => {
  const url = `${API_ROOT}/${COLLECTIONS.GLOSSARY}/--all--/get_recs`;
  return _getAxios(url);
};
export const getAllTypes = () => {
  const url = `${API_ROOT}/${COLLECTIONS.TYPE_PROTOS}/--all--/get_recs`;
  return _getAxios(url);
};

export const getCatRootNodesByPattern = (pattern) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/${pattern}/get_recs`;
  return _getAxios(url);
};
export const getRecordRootNodesByPattern = (pattern) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${pattern}/get_recs`;
  return _getAxios(url);
};
export const getTemplateRootNodesByPattern = (pattern) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${pattern}/get_recs`;
  return _getAxios(url);
};
export const getUomsByPattern = (pattern) => {
  const url = `${API_ROOT}/${COLLECTIONS.UOMS}/${pattern}/get_recs`;
  return _getAxios(url);
};

export const getTypesByPattern = (pattern) => {
  const url = `${API_ROOT}/${COLLECTIONS.TYPE_PROTOS}/${pattern}/get_recs`;
  return _getAxios(url);
};

export const getCatTree = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/${my_id}/get_whole_rec`;
  return _getAxios(url);
};
export const getRecordTree = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${my_id}/get_whole_rec`;
  return _getAxios(url);
};
export const getTemplateTree = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${my_id}/get_whole_rec`;
  return _getAxios(url);
};
export const getUom = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.UOMS}/${my_id}/get_whole_rec`;
  return _getAxios(url);
};
export const getGlossary = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.GLOSSARY}/${my_id}/get_whole_rec`;
  return _getAxios(url);
};
export const getLikelyValuesByName = (fieldName) => {
  const encodedFieldName = encodeURI(fieldName);
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${encodedFieldName}/fetch_values_by_name`;
  return _getAxios(url);
};
export const getType = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.TYPE_PROTOS}/${my_id}/get_whole_rec`;
  return _getAxios(url);
};

export const getCatChildrenNodes = (parent_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/${parent_id}/get_children`;
  return _getAxios(url);
};
export const getRecordChildrenNodes = (parent_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${parent_id}/get_children`;
  return _getAxios(url);
};
export const getTemplateChildrenNodes = (parent_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${parent_id}/get_children`;
  return _getAxios(url);
};

export const getRecordParentNode = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${my_id}/get_parent`;
  return _getAxios(url);
};

export const getCatSiblingNodes = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/${my_id}/get_siblings`;
  return _getAxios(url);
};
export const getRecordSiblingNodes = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${my_id}/get_siblings`;
  return _getAxios(url);
};
export const getTemplateSiblingNodes = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${my_id}/get_siblings`;
  return _getAxios(url);
};

export const deleteCatTree = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/${my_id}/delete_node`;
  return _getAxios(url);
};
export const deleteRecordTree = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${my_id}/delete_node`;
  return _getAxios(url);
};
export const deleteTemplateTree = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${my_id}/delete_node`;
  return _getAxios(url);
};
export const deleteUom = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.UOMS}/${my_id}/delete_node`;
  return _getAxios(url);
};
export const deleteGlossary = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.GLOSSARY}/${my_id}/delete_node`;
  return _getAxios(url);
};
export const deleteType = (my_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.TYPE_PROTOS}/${my_id}/delete_node`;
  return _getAxios(url);
};
/* Category payload for a single node:
 { id: this node's id
   name: xxxx,
   parent:  parent_id (null if no parents)
   value: '',
   child_count: child count or 0
   meta: {varies depending on type. note: if no value field, then no meta}
   children: [array of children whose length is child_count or empty]
 }
*/
export const updateCat = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/update_whole_rec`;
  return _postAxios(url, payload);
};
export const updateRecord = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/update_whole_rec`;
  return _postAxios(url, payload);
};
export const updateTemplate = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/update_whole_rec`;
  return _postAxios(url, payload);
};
export const updateUom = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.UOMS}/update_whole_rec`;
  return _postAxios(url, payload);
};
export const getGlossarysByPattern = (payload) => {
  const url = `${API_ROOT}/starts_with`;
  return _postAxios(url, payload);
};
export const updateGlossary = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.GLOSSARY}/update_whole_rec`;
  return _postAxios(url, payload);
};
export const updateType = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.TYPE_PROTOWS}/update_whole_rec`;
  return _postAxios(url, payload);
};

export const updateCatNode = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/update_rec`;
  return _postAxios(url, payload);
};
export const updateRecordNode = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/update_rec`;
  return _postAxios(url, payload);
};
export const updateTemplateNode = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/update_rec`;
  return _postAxios(url, payload);
};

/* Category payload for a single node:
 { name: xxxx,
   parent:  parent_id (null if no parents)
   value: '',
   child_count: 0
   meta: {varies depending on type. note: if no value field, then no meta}
   children: []
 }
 */
export const createCat = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/create_rec`;
  return _postAxios(url, payload);
};
export const createRecord = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/create_rec`;
  return _postAxios(url, payload);
};
export const createTemplate = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/create_rec`;
  return _postAxios(url, payload);
};
export const createUom = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.UOMS}/create_rec`;
  return _postAxios(url, payload);
};
export const createGlossary = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.GLOSSARY}/create_rec`;
  return _postAxios(url, payload);
};
export const createType = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.TYPE_PROTOS}/create_rec`;
  return _postAxios(url, payload);
};

export const mergeCatToRecord = ({ cat_id, record_node_id }) => {
  const pre_url = `${API_ROOT}/${COLLECTIONS.CATEGORIES}/${cat_id}`;
  const url =
    pre_url + `/${COLLECTIONS.RECORDS}/${record_node_id}/merge_sub_tree`;
  return _getAxios(url);
};

export const mergeTemplateToRecord = ({ template_id, cat_id }) => {
  const pre_url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${template_id}`;
  const url = pre_url + `/${COLLECTIONS.RECORDS}/${cat_id}/merge_template`;
  return _getAxios(url);
};

/*
 *  Create a template from a given node.
 *  The node is identified by its _id.
 *  The template name must be unique.
 *  The new template _id is returned as {'Success': _id}
 */
export const createTemplateFromNode = ({ node_id, template_name }) => {
  const pre_url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${COLLECTIONS.TEMPLATES}/${node_id}`;
  const url = pre_url + `/${template_name}/create_template_from_node`;
  return _getAxios(url);
};
/*
 *  Create a template from a given record.
 *  The record is identified by its _id.
 *  The template name must be unique.
 *  The new template _id is returned as {'Success': _id}
 */
export const createTemplateFromRecord = ({ rec_id, template_name }) => {
  const pre_url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${COLLECTIONS.TEMPLATES}/${rec_id}`;
  const url = pre_url + `/${template_name}/create_template_from_record`;
  return _getAxios(url);
};

/*
 * Ceate a new record from a template.
 * The template is identified by its id.
 * The record name must be unique.
 * The new record _id is returned as {'Success': _id}
 */
export const createRecordFromTemplate = ({ template_id, record_name }) => {
  const pre_url = `${API_ROOT}/${COLLECTIONS.TEMPLATES}/${COLLECTIONS.RECORDS}/${template_id}`;
  const url = pre_url + `/${record_name}/create_record_from_template`;
  return _getAxios(url);
};

/*
 * Replace one node with another in the specified record
 */
export const replaceNodeInRecord = ({ rec_id, node_id }, payload) => {
  const url = `${NODE_API}/${COLLECTIONS.RECORDS}/${rec_id}/${node_id}/replace_node/`;
  return _postAxios(url, payload);
};

/*
 * Duplicate a noe tree and attach it to the original parent
 */
export const duplicateNodeTreeToRecord = (cat_id) => {
  const url = `${NODE_API}/${COLLECTIONS.RECORDS}/${cat_id}/duplicate_node/`;
  return _getAxios(url);
};

/*
 * Get a score for a particular node in a record
 */
export const scoreNode = ({ rec_id, node_id }) => {
  const url = `${SCORE_API}/${COLLECTIONS.RECORDS}/${rec_id}/${node_id}/score/`;
  return _getAxios(url);
};

/*
 * Clinical Decision Guideness API
 */

/*
 * Get list of categories that can be analyzed
 */
export const getAnalysisCategories = () => {
  const url = `${CDG_API}/${COLLECTIONS.RECORDS}/`;
  return _getAxios(url);
};

/*
 * Get state id for a particular record
 */
export const getStateId = (rec_id) => {
  const url = `${CDG_API}/${COLLECTIONS.RECORDS}/${rec_id}/fetch_state_id/`;
  return _getAxios(url);
};

/*
 * Post a request for analysis
 * {
 *   "state_id": "71014c49dc188edcc40045b507b305c5",
 *   "categories": ["Labs", "Diagnosis"],
 *   "sample_size": 5
 * }
 */
export const fetchCommonalities = (payload) => {
  const url = `${CDG_API}/${COLLECTIONS.RECORDS}/fetch_commonalities`;
  return _postAxios(url, payload);
};
/*
 * Request current datetime for adding entries
 */
export const getDateTime = () => {
  const url = `${API_ROOT}/cur_datetime`;
  return _getAxios(url);
};
/*
 * Orders
 */
/*
 * Returns all orders from a record
 */
export const getOrdersForRecord = (rec_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order/${rec_id}`;
  return _getAxios(url);
};
/*
 * Returns a single order from a record
 */
export const getOrderForRecordById = (rec_id, order_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order/${rec_id}/${order_id}`;
  return _getAxios(url);
};
/*
 * Creates a new order for a specific record
 */
export const createOrderForRecord = (payload) => {
  const url = `${ORDER_API}/${COLLECTIONS.RECORDS}/${payload.record_id}/`;
  return _postAxios(url, payload);
};
/*
 * Updates an existing order for a specific record
 */
export const updateOrderForRecordById = (payload) => {
  const url = `${ORDER_API}/${COLLECTIONS.RECORDS}/${payload.record_id}/`;
  return _putAxios(url, payload);
};
/*
 * Removes a single order from a record
 */
export const deleteOrderById = (rec_id, order_id) => {
  const payload = {
    order_id: order_id,
  };
  const url = `${ORDER_API}/${COLLECTIONS.RECORDS}/${rec_id}/`;
  return _deleteAxios(url, payload);
};
/*
 * Returns all records that contain an order with a specified issuer
 */
export const getAllRecordsWithSpecifiedOrderIssuer = (issuer_username) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/issuer_records/${issuer_username}`;
  return _getAxios(url);
};
/*
 * Notifications
 */
/*
 * Returns all notifications for a record
 */
export const getNotificationsForRecord = (rec_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification/${rec_id}`;
  return _getAxios(url);
};
/*
 * Returns a single notification from a record
 */
export const getNotificationForRecordById = (rec_id, notification_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification/${rec_id}/${notification_id}`;
  return _getAxios(url);
};
/*
 * Creates a new notification for a specific order
 */
export const createNotificationForOrder = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification`;
  return _postAxios(url, payload);
};
/*
 * Updates an existing order for a specific record
 */
export const updateNotificationForOrderById = (payload) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification`;
  return _putAxios(url, payload);
};
/*
 * Removes a single notification from a record
 */
export const deleteNotificationById = (rec_id, order_id) => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification/${rec_id}/${order_id}`;
  return _deleteAxios(url);
};
/*
 * Roles
 */
/*
 * Returns all roles for a specific user
 */
export const getRolesForUser = (account_name) => {
  const url = `${ACCESS_API}/${account_name}/get-role/`;
  return _getAxios(url);
};
/*
 * Returns all roles for the logged in user
 */
export const getRolesForLoggedInUser = () => {
  const url = `${ACCESS_API}/get-role/`;
  return _getAxios(url);
};
